module.exports = function() {
	return new Worker(__webpack_public_path__ + "ab7436e6898bb5794887.worker.js");
};


// WEBPACK FOOTER //
// ./src/genetic/evolution.worker.js